import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import App from "./App";
import theme from "./theme/theme";
import { registerMaterialentnahmeServiceWorker } from "./services/serviceWorkerService";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Direkt registrieren statt erst auf das load-Ereignis zu warten. So wird auch
// in installierten PWAs und bei bereits vollständig geladenen Dev-Seiten jeder
// Startversuch diagnostisch erfasst.
void registerMaterialentnahmeServiceWorker();
